import { useTranslation } from 'react-i18next'

import useSWR from 'swr'

import { FetchError } from '../../../data/fetchError'
import { FetchResponse } from '../../../data/fetchResponse'
import { FetchResult } from '../../../data/fetchResult'
import { fetchJson } from '../../../data/fetchers'
import { TrialTemplateDto } from './model'

export function useAllTrialTemplates(): FetchResult<TrialTemplateDto[]> {
  const { i18n } = useTranslation()

  let url = `/trial/templates`
  if (i18n.language) url = `${url}/?language=${encodeURI(i18n.language)}`

  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<TrialTemplateDto[]>,
    FetchError
  >(url, fetchJson<TrialTemplateDto[]>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}
